const getApiUrl = () => (
  process.env.NODE_ENV === 'development'
    ? 'localhost:9000'
    : `${window.location.protocol}//${window.location.host}`
)

export default getApiUrl
